import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

import translationES from "./es/translation.json";

const resources = {
  es: { translation: translationES },
};

i18n.use(Backend).use(initReactI18next).init({
  resources,
  fallbackLng: "es",
  debug: true,
});

export default i18n;
